import React from 'react'

class AssignedPairingList extends React.Component {
  render() {
    return (
      <div className="table-responsive">
        <table className="table table-sm table-stripped">
          <thead className="thead-dark">
            <tr>
              <th scope="col">Index</th>
              <th scope="col">Número de serie</th>
              <th scope="col">PIN</th>
            </tr>
          </thead>
          <tbody>
            {this.props.RegisterLockers.map((registerlocker, index) => (
              <tr>
                <td>
                  {index +1}
                </td>
                <th scope="row">{registerlocker.SN}</th>
                <td scope="row">{registerlocker.Pin}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }
}

export default AssignedPairingList
